import * as ApiManager from './_manager';
import store from '@/store';

export const page = {
  create: (payload = null) => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/page/create`,
      payload
    );
  },

  get: (payload = null) => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/page/get`,
      payload
    );
  },

  list: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/page/list`,
      payload
    );
  },

  delete: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/page/${payload.id}/delete`,
      payload
    );
  },

  update: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/page/` +
        payload.id +
        `/update`,
      payload
    );
  },
};
